import { Popover, styled } from '@mui/material';

import CalendarMonth from '@common/assets/icons/CalendarMonth.svg';

export const StyledDatePickerWrap = styled('div')(() => ({
	display: 'flex',
	alignItems: 'center',

	gap: '8px',
	flexBasis: '100%',
	justifyContent: 'space-between',
}));

export const StyledDatePickerPopover = styled(Popover)({});

export const StyledDatePickerCalendarMonth = styled(CalendarMonth, {
	shouldForwardProp: (prop) => prop !== 'isOpen',
})<{ isOpen?: boolean }>(({ theme, isOpen }) => ({
	cursor: 'pointer',

	color: isOpen ? theme.palette.primary.main : 'inherit',
}));
